import { AutogenModelSmsControl, AutogenRowSmsControl } from "./autogen/AutogenModelSmsControl";

export class ModelSmsControl extends AutogenModelSmsControl<RowSmsControl> {
	constructor() {
		super(RowSmsControl);
	}
}

export class RowSmsControl extends AutogenRowSmsControl {
}